import { render } from "./QuoteBase.vue?vue&type=template&id=059cfc42&ts=true"
import script from "./QuoteBase.vue?vue&type=script&lang=ts"
export * from "./QuoteBase.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__